import React from 'react';
import '../Styles/Contributors.css';

const Contributors = () => {
  return (
<>
    <header> Hi how are you </header>
    <div className='con-body'>Contributors</div>
</>
  )
}
export default Contributors;